import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: '1.6'
    }}>
      <h1 style={{ color: '#333', marginBottom: '2rem' }}>Terms of Service</h1>
      
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <h2>Acceptance of Terms</h2>
      <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
      
      <h2>Use License</h2>
      <p>Permission is granted to temporarily download one copy of the materials on this website for personal, non-commercial transitory viewing only.</p>
      
      <h2>Disclaimer</h2>
      <p>The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
      
      <h2>Limitations</h2>
      <p>In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website.</p>
      
      <h2>Revisions and Errata</h2>
      <p>The materials appearing on our website could include technical, typographical, or photographic errors. We do not warrant that any of the materials on our website are accurate, complete or current.</p>
      
      <h2>Contact Information</h2>
      <p>If you have any questions about these Terms of Service, please contact us at legal@example.com.</p>
    </div>
  );
};

export default TermsOfService;
